import { useDispatch, useSelector } from "react-redux";
import { setCurrentView } from "../../redux/assignCourse/actions";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar";
import _ from "lodash";
import SliderCourseListing from "./SliderCourseListing";
import AssignCourseModal from "../modal/AssignCourseModal";

const LearningPathCard = (props) => {

    const dispatch = useDispatch();
	const navigate = useNavigate();

    const userRole = useSelector((state) => state.user.role);

    const [show, setShow] = useState(false);

    const {
        learning,
        index,
        isMobile,
        learningListingData,
    } = props

    const showProgessNaming = (progress) => {
        if (_.toNumber(progress) === 0) {
          return "Not Started";
        } else if (_.toNumber(progress) === 100) {
          return "Completed";
        } else {
          return "In Progress";
        }
      };

    return (
        <>
            <div
                key={"learning-" + index}
                className={`${(index + 1) % 2 === 0 ? "learning" : ""}`}
                id={"learning-" + learning.id}
            >
                <div className="container mb-5">
                    <div className="row">
                        <div className="learn-head">
                            <p className="head-title">{learning.prgm_nm}</p>
                            {userRole === "manager" ? (
                                <div className="col-xl-6 col-lg-6 d-flex justify-content-lg-end team-assign-sec">
                                    <div className="text-box-rs d-flex">
                                        <div className="img-leftbef">
                                            <img src="/images/TeamBenefit.svg" alt="team" />
                                        </div>
                                        <div className="benefot">
                                            Get your team to <br></br>benefit from this Action Path
                                        </div>
                                    </div>
                                    <div className="button-sec">
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-block setup-button"
                                            onClick={() => {
                                                dispatch(setCurrentView(1));
                                                setShow(true);
                                            }}
                                        >
                                            + Assign
                                        </button>
                                        <button
                                            type="button"
                                            className="btn btn-primary btn-block setup-button"
                                            onClick={() => {
                                                let parentId = learning.id
                                                let origin = "broker";
                                                navigate("/assigned-users?parentId=" + parentId + "&origin=" + origin + "&parentName=learningpath&isMobile=" + isMobile)
                                            }}
                                        >
                                            View Assigned
                                        </button>
                                    </div>
                                </div>
                            ) : (
                                ""
                            )}
                        </div>
                        <div className="mb-4">
                            <div
                                className="col-md-12"
                                title={learning.description}
                                dangerouslySetInnerHTML={{
                                    __html:
                                        learning.prgm_description
                                }}
                            ></div>
                        </div>
                        <div className="container-pie">
                            <div className="container-chart">
                                <div className="box d-flex align-items-baseline mb-2">
                                    <div
                                        className="chart-7"
                                        style={{
                                            width: 150,
                                            height: 150,
                                            position: "relative",
                                        }}
                                    >
                                        <CircularProgressbar
                                            value={learning.prgm_progress}
                                            text={`${isNaN(learning.prgm_progress) ? _.toNumber(learning.prgm_progress).toFixed(0) : learning.prgm_progress.toFixed(0)}%`}
                                            styles={buildStyles({
                                                pathColor:
                                                    96 < 100 ? `#6CC869` : "#6CC869", //FF9700=yellow
                                                trailColor: "#EBEBEB",
                                                textSize: "16px",
                                                text: {
                                                    fontSize: "16px",
                                                    fontWeight: "bold",
                                                    fill: "#000",
                                                    fontFamily: "Inter",
                                                },
                                            })}
                                        />
                                    </div>
                                    <p className="chart-content">
                                        {showProgessNaming(learning.prgm_progress)}
                                    </p>
                                    {/* <button type="button"
                                        className="btn btn-primary btn-block setup-button ml-2 cursor-pointer"
                                        onClick={() => {
                                            setShowInfoModal(true)
                                            setShowLearningData(learning)
                                        }}
                                    >Info</button> */}
                                </div>
                            </div>
                        </div>
                        {learning.coursesList.length > 0 ? (
                            <SliderCourseListing
                                isOnboarding={
                                    learning.is_onboarding ? true : false
                                }
                                coursesList={learning.coursesList}
                                setFavoriteCourse={() => {}}
                                closeModal={""}
                                setCloseModal={() => {}}
                                hasDescription={false}
                                pageType="course"
                                showBlankCard={false}
                                id={learning.id}
                                path="/learning-paths"
                                index={0}
                                isLP={true}
                            />
                        ) : (
                            "No courses found"
                        )}
                    </div>
                </div>
                <div>
                    {index === learningListingData.length - 1 ? (
                        ""
                    ) : (
                        <div className="center_line"></div>
                    )}
                </div>
            </div>
            <AssignCourseModal
                show={show}
                parentName={"Action Path"}
                parentId={learning.id}
                setShow={setShow}
                origin={"broker"}
                isMobile={isMobile}
            />
        </>
    )
}

export default LearningPathCard